import FormalNavBar from './FormalNavBar';

export default FormalNavBar;
